var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","text-align":"right"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.handleExport}},[_c('v-icon',[_vm._v("mdi-microsoft-excel")]),_vm._v(" Export ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }